module.exports = __webpack_public_path__ + "img/11.fbfe66d4.jpg";